export default {
    name: "BaseInput",
    props: {
        initValue: {
            type: [Number, String],
            default: '',
        },
        label: {
            type: [Number, String],
            default: '',
        },
        type: {
            type: String,
            default: 'light'
        }
    },
    computed: {
        showLabel() {
            return this.label.length > 0;
        }
    },
    data() {
        return {
            value: this.initValue,
        }
    },
}